import { Controller } from "@hotwired/stimulus"

// 전문가 재검토 배너 — [확인] 클릭 시 서버에 ack 기록(PATCH) 후 배너 제거.
// 서버 기록이라 브라우저 캐시를 비워도 다시 뜨지 않는다 (이론적 평가 결과가
// 또 바뀌면 서버 조건상 재등장).
//
// 사용:
//   <div data-controller="reeval-banner" data-reeval-banner-url-value="/.../acknowledge_reeval">
//     <button data-action="click->reeval-banner#dismiss">확인</button>
//   </div>
export default class extends Controller {
  static values = { url: String }

  dismiss(event) {
    if (event) event.preventDefault()
    // 낙관적 제거 — 즉시 숨기고, 실패해도 사용자 흐름은 막지 않음.
    this.element.classList.add("hidden")

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
        Accept: "application/json"
      },
      credentials: "same-origin"
    }).catch(() => {
      // 네트워크 실패는 조용히 무시 — 다음 로드 시 조건에 따라 다시 뜰 수 있음.
    })
  }
}
